<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "app",
  components: {},
  data() {
    return {
      navHistory: []
    };
  },
  computed: {},
  methods: {},
  mounted() {
    // this.$root.$on("navigate", (back, nav) => {
    //   this.navigate(back, nav);
    // });
  },
  beforeDestroy() {
    // this.$root.$off("navigate");
  }
};
</script>

 <style>
@import "assets/animate.css";
@import "assets/fonts/stylesheet.css";
</style>

<style lang="scss">
#app {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  height: 100%;
  width: 100%;
  position: relative;
  font-weight: normal;
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  font-size: 20px;
  overflow: none;
  background-color: rgba(223, 228, 232, 0.25);
  font-family: "VW Text";
  font-weight: 300;
}
</style>

<style >
/* @media (max-width: 1300px) {
  html,
  body {
    font-size: 14px;
  }
}

@media (max-width: 1000px) {
  html,
  body {
    font-size: 12px;
  }
} */
</style>